import { PipeTransform } from '@angular/core';
var RequestStatusPipe = /** @class */ (function () {
    function RequestStatusPipe() {
    }
    RequestStatusPipe.prototype.transform = function (requestCode, cancelled, completed) {
        if (requestCode == null) {
            return '';
        }
        switch (requestCode) {
            case 'DENIED': // Denied by the board as a time request
            case 'UNAVAIL': // Marked as unavailable information by the supervisor/facilitator
            case 'COMPLETED': // Marked as completed with information by the supervisor/facilitator
                return 'Closed';
            case 'CANCELLED': // Marked as cancelled by board member
                return 'Cancelled';
            case 'CLOSEDNONINFO': // Marked as closed/non info
                return 'Closed';
            case 'FOLLOWUP': // Requested follow-up
                return 'Follow-Up Requested';
            default:
                return 'Open';
        }
    };
    return RequestStatusPipe;
}());
export { RequestStatusPipe };
